import { Subject } from 'rxjs';
import { NativeQ } from '../data/native-q';
import { Strings } from '../generated/strings';
import { DeferredData, Rpc } from './rpc';

export class RpcSubjectServer<TData, TResult> {
    public subject = new Subject<DeferredData<TData, TResult>>();

    constructor(protected rpc: Rpc, command: string) {
        this.rpc.registerInboundHandler(command, this.handler.bind(this));
    }

    protected processNextForSubject(command: string, data: TData): Promise<TResult> {
        if (this.subject.closed) {
            const message = MsftSme.getStrings<Strings>().MsftSmeShell.Core.Error.RpcSubjectClosed.message;
            throw new Error(message.format(command));
        }

        const deferredData: DeferredData<TData, TResult> = {
            data: data,
            deferred: NativeQ.defer<TResult>()
        };
        this.subject.next(deferredData);
        return deferredData.deferred.promise;
    }

    // eslint-disable-next-line unused-imports/no-unused-vars
    protected handler(data: TData): Promise<TResult> {
        throw Error('Not implemented handler');
    }
}
